import React from 'react';
import {Auth} from 'aws-amplify';
import {Button, ControlLabel, Form, FormControl, FormGroup} from 'react-bootstrap';
import './Login.css';
import ErrorComponent from '../ErrorComponent';

class VerifyPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      verificationCode: '',
      email: '',
      error: false
    };

    this.confirmUser = this.confirmUser.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  confirmUser(event) {
    event.preventDefault();
    Auth.confirmSignUp(this.state.email, this.state.verificationCode, {
      // Optional. Force user confirmation irrespective of existing alias. By default set to True.
      forceAliasCreation: true
    }).then(() => {
      this.props.history.push('/login');
    })
      .catch(() => {
        this.setState({error: true});
    });
  }

  onChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }


  render() {
    return (
      <div>
        {this.state.error &&
          <ErrorComponent error={[{msg: 'Invalid email or verification code.'}]}/>
        }
        <Form onSubmit={this.confirmUser} className='max-width'>
          <FormGroup>
            <ControlLabel>Email:</ControlLabel>
            <FormControl bsSize="large" onChange={this.onChange} name='email' type='text' value={this.state.email}/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Verification Code:</ControlLabel>
            <FormControl bsSize="large" onChange={this.onChange} name='verificationCode' type='text' value={this.state.verificationCode}/>
          </FormGroup>
          <FormGroup>
            <Button block bsSize="large" className='secondary' type='submit'>Submit</Button>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default VerifyPage;


// WEBPACK FOOTER //
// ./src/components/user/VerifyPage.js